const DEFAULT_ALERT_REDUX_STATE = {
  alertsInitialized: false,
  alerts: [],
};

export default DEFAULT_ALERT_REDUX_STATE;
